import React from 'react';
import { FileText, Layers, Settings } from 'lucide-react';

const TABS = [
  { id: 'pages', label: 'Pages', icon: FileText },
  { id: 'layers', label: 'Layers', icon: Layers },
  { id: 'settings', label: 'Settings', icon: Settings },
];

/**
 * TabBar - Horizontal tabs for the left panel
 *
 * Tabs: Pages | Layers | Settings
 * Minimalist design inspired by Framer
 */
export default function TabBar({ activeTab, onTabChange }) {
  return (
    <div className="flex border-b border-gray-200 bg-gray-50">
      {TABS.map((tab) => {
        const Icon = tab.icon;
        const isActive = activeTab === tab.id;

        return (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`
              flex-1 flex items-center justify-center gap-1.5 py-2.5 px-2
              text-xs font-medium transition-colors
              ${isActive
                ? 'text-blue-600 border-b-2 border-blue-600 -mb-px bg-white'
                : 'text-gray-500 hover:text-gray-700 hover:bg-gray-100'
              }
            `}
          >
            <Icon className="w-3.5 h-3.5" />
            <span className="hidden sm:inline">{tab.label}</span>
          </button>
        );
      })}
    </div>
  );
}
